// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import ProductAddToCartButton from "@adl/Overrides/Components/ProductAddToCartButton";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ButtonPresentationProps } from "@insite/mobius/Button";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

// <Xng-Changes>
interface OwnProps {
    iconOnly?: boolean;
}
// <Xng-Changes>

const mapStateToProps = (state: ApplicationState, ownProps: HasProduct) => ({
    configurationSelection: state.pages.productDetails.configurationSelection,
    configurationCompleted: state.pages.productDetails.configurationCompleted,
    variantSelectionCompleted: state.pages.productDetails.variantSelectionCompleted,
    subscription: state.pages.productDetails.subscription,
});

type Props = OwnProps & WidgetProps & HasProduct & ReturnType<typeof mapStateToProps>;

export interface ProductDetailsAddToCartButtonStyles {
    button?: ButtonPresentationProps;
}

export const addToCartButtonStyles: ProductDetailsAddToCartButtonStyles = {
    button: {
        sizeVariant: "small",
        css: css`
            flex-grow: 1;
        `,
    },
};

const styles = addToCartButtonStyles;

const ProductDetailsAddToCartButton = ({
    configurationSelection,
    configurationCompleted,
    variantSelectionCompleted,
    subscription,
    // xng-changes
    iconOnly,
    productInfo,
}: Props) => {
    return (
        <ProductAddToCartButton
            configurationSelection={configurationSelection}
            configurationCompleted={configurationCompleted}
            variantSelectionCompleted={variantSelectionCompleted}
            subscription={subscription}
            extendedStyles={styles.button}
            data-test-selector="addProductToCart"
            // xng-changes
            {...{ iconOnly }}
            isDisabled={!productInfo.inventory || productInfo.inventory.additionalResults?.addToCart === "false"}
        />
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(connect(mapStateToProps)(ProductDetailsAddToCartButton)),
    definition: {
        displayName: "Add to Cart Button",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
